<template>
<div id="container">

   <MapSelectOverlay msg="TAX SHEET INDEX"/> <!--  id="map-selector"  -->
   <div id="map">
    <!--     <iframe title="Tax Map" id="pdf" width="100%" height="100%" :src="this.imagesrc" type="application/pdf" ></iframe> -->
       
    <!-- <object title="Tax Map" id="pdf" :data="this.imagesrc" type="application/pdf" width="100%" height="100%"></object> -->

  <iframe title="Tax Map"  id="pdf" :src="this.imagesrc" width="100%" height="100%" style="border: none;">
This browser does not support PDFs. Please download the PDF to view it: <a :href="this.imagesrc">Download PDF</a>
</iframe>

       
       
        <div class="center-center" v-bind:class="{ hide: hideInstructions }">
            <h2>Instructions</h2> 
            <h3>Option 1</h3> 
            <p >Select a <strong class="control">Municipality</strong>, then a <strong class="control">Tax Sheet</strong> from the drop-down lists.</p>
            
            <h3>Option 2 <small>(desktop only)</small></h3> 
            <p >Navigate to a place of interest on the <strong class="control">Map</strong>, and <strong>"click"</strong>.</p>
            <br>
            
            <h3>Notes</h3> 
            <p >Hovering with the mouse pointer near the top or right of a tax map<br>
            will activate toolbars to pan, zoom, rotate and print the pdf.</p>
            <br>
            <p>This site is not supported in <strong class="browser">IE</strong>. It is best supported in <strong class="browser">Chrome</strong> and<br>
            <strong class="browser">Firefox</strong> browsers.</p>
        </div>
   </div>
     
</div>
</template>

<script>
    // @ is an alias to /src
    import MapSelectOverlay from '@/components/MapSelectOverlay.vue'
    import ESRIMap from '@/components/ESRIMap.vue'
   import {mapGetters,mapActions} from 'vuex'
   //import {mapState,mapGetters,mapActions} from 'vuex'      //stu 12/27/2021
   import * as lookup from '@/helpers/taxsheet';
    
    export default {
      //eslint-disable-next-line
        name: 'taxmap',
        components: {
      //eslint-disable-next-line
          MapSelectOverlay,ESRIMap
        },
        props: ['muni','ts'],
       beforeRouteEnter (to, from, next) { 
            next(vm => { 
                // access to component's instance using `vm` . this is done because this navigation guard is called before the component is created.
        let muni = to.params.muni;
      
                let ts = to.params.ts;
                
                vm.initializeSearch(muni,ts);
                next();
            }) 
          }, 
        data () {
          return {
          hideInstructions:false,
          }
        },
        mouted () {
        // this.$store.dispatch('initializeMunicipalities');
        // this.$store.dispatch('initializeSheetlist'); 
        // console.log(this.$store.getters.indexsheets)
        window.addEventListener(
            'popstate', this.handleHistoryChange
            ) 
    },

    destroyed () {
        window.removeEventListener(
                'popstate', this.handleHistoryChange
            ) 
      },
        created(){
            let pmuni = this.$route.params.muni;
            this.$store.commit('updateMunicipalID', muni)
            let muni =  this.municipalities.filter(fld => fld.ID === pmuni)[0]
            
            this.updateCenter(muni.center); 
            this.updateExtent(muni.extent); 
            this.updateZoom(10); 

            let ts = this.$route.params.ts;
            this.routeInit(ts, muni); 

        },

        computed: {
            ...mapGetters({imagesrc:'imagesrc'}),
            
            municipalities(){
                  return lookup['MunicipalIDNJSP'];
            },
        },
        watch:{
            imagesrc: function (val) {
            if (val !== "" )
              {
                this.hideInstructions = true    
              }
          },
          // call again the method if the route changes
          '$route': 'handleHistoryChange'
        },
        methods:{
            ...mapActions(['updateCenter','updateExtent','updateZoom','routeInit']), 

            initializeSearch(muni,ts){
                
                  this.$store.dispatch('mapSelect', {ts, muni});
                  
                  },
            handleHistoryChange(){
                //  alert('routechanged');
                  }
        }
    }
</script>
<style scoped>
      #container {
        text-align: center;
        color: white;
        grid-gap: 0;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
        display: -ms-grid;
        -ms-grid-columns: max-content 1fr;
        -ms-grid-rows: max-content 1fr;
        display: grid;
        grid-template-columns: max-content 1fr;
        grid-template-rows: max-content 1fr;
      }

      #map-selector {
        text-align: center;
        margin-top: 0;
        background: rgba(15, 1, 1, 0.726);
        display: grid;
        grid-column: 1;
        -ms-grid-column: 1;
        grid-row: 1/2;
        -ms-grid-row: 1;
        z-index:3
      }

      #map {
        grid-column: 1 / 3;
        -ms-grid-column-span: 2;
        grid-row: 1 / 3;
        -ms-grid-row-span: 2;
        z-index:0;
        background: rgb(94, 89, 89);
      }
      #nomap {
        grid-column: 1 / 3;
        -ms-grid-column-span: 2;
        grid-row: 1 / 3;
        -ms-grid-row-span: 2;
        z-index:0;
        background: rgb(94, 89, 89);
      }

      #pdf{
        height:100%;
        width:100%;
        z-index: -99;
      }


      .center-center{
        position: absolute;
        text-align: left;              
        top: 40%;
        left: calc(50% + 100px);                         
        margin-right: -60%;
        transform: translate(-40%, -50%);
        background-color: #5e6e2e;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
        -webkit-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);    
      }

      .center-center.hide{
        display:none;
      }

      h2{
        color: rgb(1, 10, 4);
        margin:10px;
        font-size: 2.5em;
        text-align: center;
        display:block; 
      }

      h3{
        color:rgb(28, 28, 36);
        margin:10px;
        font-size: 1.5em;
      }

      p{
        margin:5px 25px;
      } 

      strong.control{
        font-style: italic;
        color: rgb(192, 17, 17); 
      }
      strong.browser{
        color: rgb(172, 246, 248); 
      }
      @media all and (max-width : 700px) {
          #map-selector {
            margin-top: 0;
            grid-column: 1/3;
            grid-row: 1/2;
            width:100%;
            background: rgba(15, 1, 1, 0.726);
            grid-column: 1/5;
            grid-row: 1/2;
            z-index:2;
            display: grid;
          }

          #map {
            margin-top: 0;
            grid-column: 1/3;
            grid-row: 2/3;
            width:100%;
          }

          embed{
            width:100%;
          } 
        
          .center-center{
            top: 56%;
            left: 50%;                         
            margin-right: -50%;
            transform: translate(-50%, -40%);
            width:90%;
          }  

          h2{
            color: #fff;
            margin:5px;
            font-size: 1.5em;
          }
          h3{
             color:rgb(28, 28, 36);
            margin:5px;
             font-size: 1.2em;
          }

          p{
             margin:2px 25px;
             font-size: .85em;
          }  
    }
</style>

